import TransactionModal from "./transactionModal.js";

export default class IncorporationModal extends TransactionModal {
  constructor(companyId, modal) {
    super(typeof modal === "string" ? modal : "incorporation-modal", companyId);

    this.triggeredChanges = {};
    this.delayedEvents = [];

    if (typeof modal === "string") {
      return;
    }
    this.companyId = companyId;
    this.amountType = "shares";
    this.totalShares = 0;
    this.totalPercentage = 0;

    this.$foundersList = this.$form.querySelector("[data-founders-list]");
    this.$addAnotherFounder = this.$form.querySelector("[data-add-founder]");
    this.$totalAmountShares = document.querySelector(
      "[data-total-amount-shares]"
    );
    this.$totalAmountPercentage = document.querySelector(
      "[data-total-amount-percentage]"
    );

    this.fields = [
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "share_price",
        varType: "float",
        required: true,
      },
      {
        name: "total_shares",
        varType: "int",
        mayNotExist: true,
      },
      {
        name: "investment",
        varType: "array",
        fields: [
          {
            name: "stakeholder",
            varType: "string",
            required: true,
          },
          {
            name: "email",
            varType: "string",
          },
          {
            name: "amount_percent",
            varType: "float",
            mayNotExist: true,
          },
          {
            name: "amount_shares",
            varType: "float",
            mayNotExist: true,
            required: true,
          },
        ],
        validation: (field, data) => {
          this.validateInvestments(field, data);
        },
      },
    ];

    this.$form.querySelector('[name="date"]').valueAsDate = new Date();

    this.$price = this.$form.querySelector('[name="price"]');
    this.$totalCompanyShares = this.$form.querySelector("[data-total-shares]");

    this.setupListeners();
    this.getAndSetFounders();
    this.setupStakeholderDatalist();

    Promise.all([this.documentsPromise, this.getShareClasses()]).then(
      (output) => {
        this.shareClass = output[1]?.[0]?.id;

        document.getElementById("invite-founders").checked = true;
        this.videoTutorials = {
          en: "https://www.youtube.com/embed/a2D0PCby9_c",
          es: "https://www.youtube.com/embed/MkGP152XeLg",
        };
        this.whenReady();
      }
    );
  }

  whenReady() {
    super.whenReady();
    if (this.countFounders() < 2) {
      this.$addAnotherFounder.click();
    }
  }

  async setupStakeholderDatalist() {
    const $container = document.getElementById(
      "incorporation-stakeholders-list"
    );
    this.stakeholders = await this.getStakeholders();

    this.stakeholders.forEach((stakeholder) => {
      const option = document.createElement("option");
      option.value = stakeholder.name;
      $container.appendChild(option);
    });
  }

  validateInvestments(field, data) {
    if (this.amountType === "percent") {
      data.investment.forEach((d) => {
        if (d["amount-percent"] < 0 || d["amount-percent"] > 100) {
          throw {
            el: field.fields[2].el[0],
            message: "",
          };
        }
      });
      if (this.totalPercent !== 100) {
        peque.navigation.showError(trans("percentage_is_not_complete"));
        throw {
          message: trans("percentage_is_not_complete"),
        };
      }
    }
  }

  setupListeners() {
    this.$addAnotherFounder.addEventListener("click", () => {
      this.addNewFounderSlot();
    });
    this.$foundersList
      .querySelector("[name='amount-type[]']")
      .addEventListener("change", (e) => {
        this.switchAmountType(e.target.value === "percent");
      });
    this.$foundersList
      .querySelector("[name='amount-percent[]']")
      .addEventListener("change", () => this.calculateTotalAmount());
    this.$foundersList
      .querySelector("[name='amount-shares[]']")
      .addEventListener("change", () => this.calculateTotalAmount());
  }

  getShareClasses() {
    return new Promise((resolve, reject) => {
      peque
        .api("shareclasses", { company: this.companyId }, "get")
        .then((response) => {
          if (response.error > 0) {
            reject();
            return;
          }
          resolve(response.result.list);
        });
    });
  }

  addNewFounderSlot() {
    const newLine = this.$foundersList
      .querySelector("[data-founder-line='1']")
      .cloneNode(true);
    const lineIndex = this.countFounders() + 1;

    newLine
      .querySelector("[data-remove-founder]")
      .addEventListener("click", () => {
        newLine.remove();
      });
    const amountType = newLine.querySelector("[name='amount-type[]']");
    amountType.addEventListener("change", (e) => {
      this.switchAmountType(e.target.value === "percent");
    });
    const amountInput = newLine.querySelector("[name='amount-percent[]']");
    amountInput.addEventListener("change", () => {
      this.calculateTotalAmount();
    });
    amountInput.addEventListener("input", () => {
      if (lineIndex === this.countFounders()) {
        this.$addAnotherFounder.click();
      }
    });
    const sharesInput = newLine.querySelector("[name='amount-shares[]']");
    sharesInput.addEventListener("change", () => {
      this.calculateTotalAmount();
    });
    sharesInput.addEventListener("input", () => {
      if (lineIndex === this.countFounders()) {
        this.$addAnotherFounder.click();
      }
    });

    newLine.setAttribute("data-founder-line", lineIndex);
    newLine.querySelectorAll("input").forEach((input) => (input.value = ""));
    amountType.value = this.amountType;

    this.$foundersList.append(newLine);
    this.setupNumericFields();
  }

  countFounders() {
    return this.$foundersList.querySelectorAll("[data-founder-line]").length;
  }

  switchAmountType(isPercent) {
    const reverseChildren = (parent) => {
      Array.from(parent.childNodes)
        .filter((child) => child.tagName === "INPUT")
        .forEach((child) => {
          parent.insertBefore(child, parent.firstChild);
        });
    };

    if (isPercent) {
      this.amountType = "percent";
      this.$totalCompanyShares.classList.remove("d-none");
      this.$totalAmountShares.classList.add("d-none");
      this.$totalAmountPercentage.classList.remove("d-none");
      this.$foundersList
        .querySelectorAll("[name='amount-percent[]']")
        .forEach((element) => {
          element.classList.remove("d-none");
          reverseChildren(element.parentElement);
        });
      this.$foundersList
        .querySelectorAll("[name='amount-shares[]']")
        .forEach((element) => {
          element.classList.add("d-none");
        });
    } else {
      this.amountType = "shares";
      this.$totalCompanyShares.classList.add("d-none");
      this.$totalAmountShares.classList.remove("d-none");
      this.$totalAmountPercentage.classList.add("d-none");
      this.$foundersList
        .querySelectorAll("[name='amount-percent[]']")
        .forEach((element) => {
          element.classList.add("d-none");
          reverseChildren(element.parentElement);
        });
      this.$foundersList
        .querySelectorAll("[name='amount-shares[]']")
        .forEach((element) => {
          element.classList.remove("d-none");
        });
    }

    this.$foundersList
      .querySelectorAll("[name='amount-type[]']")
      .forEach((element) => {
        element.value = isPercent ? "percent" : "shares";
      });

    this.fields[2].required = isPercent;
    this.fields[3].fields[2].required = isPercent;
    this.fields[3].fields[3].required = !isPercent;
    this.setupNumericFields();
  }

  calculateTotalAmount() {
    const getTotalAmount = (name) => {
      return Array.from(
        this.$foundersList.querySelectorAll(`[name='${name}']`)
      ).reduce((count, el) => {
        return (
          count +
          (this.amountType === "percent"
            ? this.getInt(name, el)
            : this.getFloat(name, el))
        );
      }, 0);
    };

    this.totalShares = getTotalAmount("amount-shares[]");
    this.totalPercent = getTotalAmount("amount-percent[]");

    this.$totalAmountShares.setAttribute(
      "data-total-amount-shares",
      this.totalShares.toString()
    );
    this.$totalAmountPercentage.setAttribute(
      "data-total-amount-percentage",
      this.totalPercent.toString()
    );
    this.$totalAmountShares.querySelector("span").innerText =
      peque.formatNumber(this.totalShares);
    this.$totalAmountPercentage.querySelector("span").innerText =
      peque.formatNumber(this.totalPercent);
  }

  removeEmptyInvestments() {
    const shares = this.$form.querySelectorAll('[name="amount-shares[]"]');
    const percents = this.$form.querySelectorAll('[name="amount-percent[]"]');

    this.$form.querySelectorAll('[name="stakeholder[]"]').forEach((el, i) => {
      if (
        el.value.length < 1 &&
        shares[i].value.length < 1 &&
        percents[i].value.length < 1
      ) {
        el.closest("[data-founder-line]").remove();
      }
    });
  }

  getAndSetFounders() {
    if (typeof window.currentCompany === "undefined") {
      return;
    }
    peque
      .api("companies/" + window.currentCompany.id + "/founders")
      .then((response) => {
        const totalFounders = response.result.list.length;

        if (totalFounders < 1) {
          return;
        }

        if (totalFounders > this.countFounders()) {
          for (let i = this.countFounders(); i < totalFounders; i++) {
            this.addNewFounderSlot();
          }
        }
        const names = this.$form.querySelectorAll('[name="stakeholder[]"]');
        const emails = this.$form.querySelectorAll('[name="email[]"]');

        response.result.list.forEach((person, i) => {
          names[i].value = person.name;
          emails[i].value = person.email;
        });
      });
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);
    this.resetFailedValidations();

    this.removeEmptyInvestments();

    this.getFields(this.fields)
      .then((data) => {
        data.company = this.companyId;
        data.type = peque.TRANSACTION_TYPE_FINANCING_ROUND;
        data.invite = document.getElementById("invite-founders").checked;
        data.name = trans("incorporation");
        data.share_class = this.shareClass;
        data.price = data.share_price;
        data.documents = [];
        data.notes = null;
        data.pools = [];

        // Calculate amounts
        data.investment = data.investment.map((i) => {
          const existingStakeholder = this.stakeholders.find(
            (s) => s.name === i.stakeholder
          );
          return {
            stakeholder: i.stakeholder,
            stakeholder_id: existingStakeholder ? existingStakeholder.id : 0,
            beneficiary: "",
            beneficiary_id: 0,
            email: i.email || "",
            discount: "",
            investment: "",
            amount:
              this.amountType === "percent"
                ? (i.amount_percent * data.total_shares) / 100
                : i.amount_shares,
          };
        });

        delete data.total_shares;
        delete data.share_price;

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            location.reload();
          })
          .catch((error) => {
            this.enableSubmitButton(true);
            peque.navigation.showError(error.error);
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);

        if (typeof error.show !== "undefined") {
          peque.navigation.showError(error.message);
          return;
        }
        if (typeof error.el === "undefined" || !error.el) {
          console.error(error);
          return;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
